import { Result } from "@/functional/result";
import { getCookie, removeCookie } from "typescript-cookie";

export interface UserIdentity {
  UserId: string;
  Roles: string;
  Email?: string;
}

export class Identity {

  public static clearIdentity(): void { 
    removeCookie("X-UserClaim-Names");
  }

  public static getIdentity(): Result<UserIdentity> {
    const identity: UserIdentity = {
      UserId: "",
      Roles: "",
    };

    try {
      const content = getCookie("X-UserClaim-Names");
      if (content === undefined) {
        return Result.fail<UserIdentity>(
          `"UserIdentity.getIdentity cookie:X-Claim-Names not found"`
        );
      }

      const temp = content.split(",");
      if (temp.length < 2) {
        return Result.fail<UserIdentity>(
          `"UserIdentity.getIdentity cookie:X-Claim-Names has wrong content"`
        );
      }

      identity.UserId = temp[0].replace("nameidentifier=", "");
      identity.Roles = temp[1].replace("Roles=", "");
    } catch (e) {
      return Result.fail<UserIdentity>(`"UserIdentity.getIdentity.Error ${e}"`);
    }
    return Result.ok<UserIdentity>(identity);
  }
}
